import { gql } from "@apollo/client";

export const LOAD_AGENCY_RESOURCES = gql`
  query LoadAgencyResources($input: LoadAgencyResourcesInput!) {
    loadAgencyResources(input: $input) {
      id
      title
      description
      keywords
      categoryId
      category {
        id
        deletedAt
        localization {
          locale
          text
          __typename
        }
        __typename
      }
      mainLocation {
        name
        website
        address {
          formattedAddress
          streetAddress
          city
          state
          postalCode
          coordinates {
            latitude
            longitude
            __typename
          }
          __typename
        }
        phones {
          number
          description
          actions
          __typename
        }
        __typename
      }
      locations {
        name
        website
        address {
          formattedAddress
          streetAddress
          city
          state
          postalCode
          coordinates {
            latitude
            longitude
            __typename
          }
          __typename
        }
        phones {
          number
          description
          actions
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
